/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CommunicationContentReadyData } from './communicationContentReadyData';
import { ToastConfig } from './toastConfig';


/**
 * WebSocket notification: the email content a user asked for has been loaded.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface CommunicationContentReadyNotification { 
    /**
     * Always \'communication.content_ready\'
     */
    readonly type: string;
    data: CommunicationContentReadyData;
    toast?: ToastConfig | null;
}
export const CommunicationContentReadyNotification_type_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommunicationContentReadyNotification_data_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommunicationContentReadyNotification_toast_Validators: ValidatorFn[] =
    [ ];


